export enum RegionConfigType {
  DEFAULT = 'DEFAULT',
  CUSTOM = 'CUSTOM',
  CITY_OVERRIDE = 'CITY_OVERRIDE',
  POSTCODE_OVERRIDE = 'POSTCODE_OVERRIDE',
  ONSHORE = 'ONSHORE',
  AGENCIES_OVERRIDE = 'AGENCIES_OVERRIDE',
  EUSS_OVERRIDE = 'EUSS_OVERRIDE'
}
export enum SectionStatusType {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}
export enum OptionStatusType {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  MANDATORY_DIRECT = 'MANDATORY',
  MANDATORY_ALL = 'MANDATORY_ALL'
}

export enum FollowUpDocStatusType {
  REQUIRED = 'REQUIRED',
  NOT_REQUIRED = 'NOT_REQUIRED',
  STAFF_ONLY = 'STAFF_ONLY',
  AGENT_ONLY = 'AGENT_ONLY'
}
export enum DocStatusType {
  INFO_ONLY = 'INFO_ONLY',
  REQUIRED = 'REQUIRED',
  NOT_REQUIRED = 'NOT_REQUIRED',
  STAFF_ONLY = 'STAFF_ONLY',
  AGENT_ONLY = 'AGENT_ONLY'
}
